<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="form-box" v-if="sail">
          <div class="form-title-wrap">
            <div class="d-flex align-items-center justify-content-between">
              <h3 class="title">Sefer Bilgisi</h3>
            </div>
          </div>
          <div class="form-content pb-2">
              <div class="table-form table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th scope="col">#</th>
                  <th>Adı</th>
                  <th>Tarih</th>
                  <th>Tur Kodu</th>
                  <th>Toplam Oda</th>
                  <th>Müsait Oda</th>
                  <th>Vize Durumu</th>
                  <th>Satış Durumu</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <th scope="row"><a :href="basePath+'/sails/'+sail.id">#{{sail.id}}</a></th>
                  <th>{{sail.cruise.name }}</th>
                  <th>{{sail.sailDate | ddMMyyyyHHmm }}</th>
                  <th>{{sail.seaTour.tourCode}}</th>
                  <th>{{sail.totalRoomCount}}</th>
                  <th>{{sail.availableRoomCount}}</th>
                  <th>
            <span v-if="sail.seaTour.visaRequired" class="badge badge-warning py-1 px-2"
                  style="color: white;">
                Vize Gerekli
            </span>
                  </th>
                  <th v-if="sail.saleOpen">
                    <span class="badge badge-success py-1 px-2">Satışa Açık</span>
                  </th>
                  <th v-if="!sail.saleOpen">
            <span class="badge badge-warning py-1 px-2"
                  style="background-color: #d32727;color: white;">
                Satışa Kapalı
            </span>
                  </th>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "sailDetailShowCase",
  props:['sail'],
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath;
      }
    },
  }
}
</script>

<style scoped>

</style>